const SsoButton = () => null;

export default SsoButton;
